const __WEBPACK_NAMESPACE_OBJECT__ = require("browser-sync-webpack-plugin");;